import { Component, EventEmitter, OnInit, OnChanges, Output, Input, ViewChild } from '@angular/core';
import { ServiceHistoryService } from 'src/app/services/service-history.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from  '@ngx-translate/core';
import { CacheService } from 'src/app/services/cache.service';
import { DIMBO_CONSTANT } from 'src/app/utils/constant';
import { AdditionalInfoDialogBoxComponent } from '../additional-info-dialog-box/additional-info-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
@Component({
  selector: 'app-service-history',
  templateUrl: './service-history.component.html',
  styleUrls: ['./service-history.component.scss']
})
export class ServiceHistoryComponent implements OnChanges, OnInit {
  panelOpenState = false;
  services = [] ;
  additionalInfoDialogBoxRef: any;
  @Input()
  reloadFirstTab: boolean; 
  /** new tab added. */
  @Output()
  addNewTab: EventEmitter<{ isNewTabAdded: boolean, serviceId: string }> = new EventEmitter(); 
  serviceId: string;
  isReadOnly: boolean = false;
  @Output()
  onserviceHistoryReload: EventEmitter<{ reloadFirstTab: boolean}> = new EventEmitter(); 
  customerVeficationRetryCount:number;
  
  @Output() additionInfoUpdated: EventEmitter<{ isAdditionInfoUpdated: boolean}> = new EventEmitter(); 

  serviceNotFound: boolean;
  shlocale: any;
  @ViewChild(CdkVirtualScrollViewport)
  viewport: CdkVirtualScrollViewport;
  @Output()
  shscrolled: EventEmitter<{ count:number  }> = new EventEmitter(); 
  @Input() isShTabSelected: boolean;
  vehicleBrandIsNotOV: boolean =true;

  constructor(private serviceHistory :ServiceHistoryService ,
    private toastrService: ToastrService ,
    private translationService: TranslateService ,
    private cacheService: CacheService ,private matDialog: MatDialog
    ) { }

  ngOnInit(): void {
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_CENTRAL_USER) === true || this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_ADMIN_USER) === true ) {
      this.isReadOnly = true; 
    } else {
      this.isReadOnly = false; 
    }
    this.customerVeficationRetryCount = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT);
    this.getServiceHistory();
    //  this.shlocale=this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL);   
    this.shlocale=this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE);  //DMBR-47: changed path for getting locale language  
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) === 'OV') {
      this.vehicleBrandIsNotOV = false; 
    }
  }

  ngOnChanges() {
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) === 'OV') {
      this.vehicleBrandIsNotOV = false; 
    }
    if (this.reloadFirstTab) {
    //  console.log('reloading 1st tab');
      this.onserviceHistoryReload.emit({reloadFirstTab: false});
      this.services=[];
      this.getServiceHistory();
      
    }
    if (!this.reloadFirstTab &&this.isShTabSelected) {
      this.viewport.scrollToIndex(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SH_SCROLL_COUNT));
    }
  }

  getServiceHistory(){
    this.serviceHistory.getServiceHistory()
      .subscribe(response => {
        if (response) {
          //console.log('FOUND...');
          
         // console.log(response);
          this.services = response;
         // console.log('service length--> ', this.services.length);
          if (this.services.length > 0) {
            this.serviceNotFound = false;
          } else {
            this.serviceNotFound = true;
            this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.notFound.serviceHistory'), this.translationService.instant('dimbo.i18n.message.toastr.warning'));
          }
          if (this.services.length > 0) {
          this.services.sort(this.sortFunction);​
          this.services.sort((a, b) => new Date(b.Date).getTime() - new Date(a.Date).getTime());
          let firstService=this.services[0];
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CURRENT_MILEAGE, firstService.mileage.value);
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT, firstService.mileage.unit);
          }
        } else {
          this.serviceNotFound = true;
        // console.log('NOT FOUND...');
          this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.notFound.serviceHistory'), this.translationService.instant('dimbo.i18n.message.toastr.warning'));
        }
        
        }, error => {
          this.serviceNotFound = true;
          if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503 || error.status === 404) && error.error) {
            this.toastrService.warning(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.toastr.warning'), {
              timeOut: 10000,
            });
        } else {
            this.toastrService.error(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.toastr.error'), {
              timeOut: 10000,
            });
        }
        });
  }

  /**
  * This method is called when clicking edit icon.
  */
 editBtnClicked(serviceId: string , accessServiceEdit: boolean) {
   if(this.isReadOnly) {
     return false;
   }
  //this.tabs.push('New');
 //.log('This accessServiceEdit  ', accessServiceEdit);
  let showAdditionalInfoDialog: boolean = false;
  this.serviceId=serviceId;
  //console.log('This service id ', this.serviceId);
 // console.log('CACHE_IS_CUSTOMER_VERIFIED: ', this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_CUSTOMER_VERIFIED));
  if(accessServiceEdit){
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_CUSTOMER_VERIFIED)) {
      showAdditionalInfoDialog = true;
    } 

    if (!showAdditionalInfoDialog) {
      if(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT) >0 ){
      this.openDialogBox('POPUP_VIEW');
    }else {
      this.toastrService.error(this.translationService.instant('dimbo.i18n.message.CustomerVerificationmsg'), '',{
        timeOut: 500000,
      });
      this.ngOnInit();
    }
    }else {
      this.addNewTab.emit({isNewTabAdded: true, serviceId:this.serviceId});
    }
  }
}


removeTab(index: number) {
  //this.tabs.splice(index, 1);
}
 /* Open popup for additional information */
 openDialogBox(eventName: string, additionalInfo?: any, isCustVerified?: boolean) {
  //console.log('here...');
  const popupData = { eventName: eventName, additionalInfo: additionalInfo, isCustVerified: isCustVerified ,isfromSH: true};
  this.additionalInfoDialogBoxRef = this.matDialog.open(AdditionalInfoDialogBoxComponent, {
    disableClose: true,
    minWidth: '450px',
    minHeight: '550px',
    data: popupData 
   // backdropClass: 'custom-dialog'
  });

  this.additionalInfoDialogBoxRef.afterClosed().subscribe((result: any) => {
    if (result) {
     // console.log('after popup close: ', result.event['isCustVerified']);
     // console.log('CACHE_IS_CUSTOMER_VERIFIED: ', this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_CUSTOMER_VERIFIED));  
      if (result.event.eventName === 'POPUP_OK') {
        if (result.event.isCustVerified) { 
          //console.log('after popup verfied');
          this.addNewTab.emit({isNewTabAdded: true, serviceId:this.serviceId});
          // Emit DB changes
          this.additionInfoUpdated.emit({isAdditionInfoUpdated: true});
        }
        else {
        //  console.log('after popup NOT verfied');
        //  console.log('CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT: ', this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT))
          let currentRetryCount = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT) - 1;
         // console.log('currentRetryCount: ', currentRetryCount);
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT, currentRetryCount);

          if (currentRetryCount < 1) {
            this.toastrService.error(this.translationService.instant('dimbo.i18n.message.CustomerVerificationFinalAttempt'), '',{
              timeOut: 50000,
            });
          } else {
            this.toastrService.error(this.translationService.instant('dimbo.i18n.message.CustomerVerificationFailed')+' '+currentRetryCount+this.translationService.instant('dimbo.i18n.message.CustomerVerificationFailed1'), '',{
              timeOut: 5000,
            });
          }

          /* this.toastrService.error(this.translationService.translate('dimbo.i18n.message.CustomerVerificationFailed')+' '+currentRetryCount+this.translationService.translate('dimbo.i18n.message.CustomerVerificationFailed1'), '',{
            timeOut: 5000,
          }); */
          
          this.ngOnInit();
        }
      }
    }
  });


}

 sortFunction(a,b){  
  var dateA = new Date(a.Date).getTime();
  var dateB = new Date(b.Date).getTime();
  return dateA < dateB ? 1 : -1;  
}

handler(event){
//console.log('handler',event);
this.shscrolled.emit({count:event});
}

}
